import React from "react";
import { StatusBadgeProps } from "../types";
import {
  WarningIcon,
  RefreshIcon,
  ClockIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "./Icons";

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label }) => {
  const getStatusStyles = () => {
    switch (status) {
      case "high-risk":
        return {
          container: "bg-[#FEE2E2] text-[#DC2626] border border-[#FCA5A5]",
          icon: <WarningIcon className="h-3 w-3 mr-1 flex-shrink-0" />,
        };
      case "expired":
        return {
          container: "bg-[#FEE2E2] text-[#DC2626] border border-[#FCA5A5]",
          icon: <RefreshIcon className="h-3 w-3 mr-1 flex-shrink-0" />,
        };
      case "upcoming":
        return {
          container: "bg-[#FEF3C7] text-[#D97706] border border-[#FCD34D]",
          icon: <ClockIcon className="h-3 w-3 mr-1 flex-shrink-0" />,
        };
      case "active":
        return {
          container: "bg-[#DCFCE7] text-[#15803D] border border-[#86EFAC]",
          icon: <CheckCircleIcon className="h-3 w-3 mr-1 flex-shrink-0" />,
        };
      case "missing":
        return {
          container: "bg-[#F3F4F6] text-[#4B5563] border border-[#D1D5DB]",
          icon: <XCircleIcon className="h-3 w-3 mr-1 flex-shrink-0" />,
        };
      default:
        return {
          container: "bg-[#F3F4F6] text-[#4B5563] border border-[#D1D5DB]",
          icon: null,
        };
    }
  };

  const { container, icon } = getStatusStyles();

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${container}`}
    >
      {icon}
      {label}
    </span>
  );
};

export default StatusBadge;
